import { Theme } from '@mui/material';
import LoadingButtonIndicator from '@/components/shared/loading-button-indicator';

const LoadingButton = (theme: Theme) => {
  return {
    MuiLoadingButton: {
      defaultProps: {
        loadingIndicator: <LoadingButtonIndicator />,
      },
      styleOverrides: {
        root: {
          '&.MuiLoadingButton-loading': {
            backgroundColor: theme.palette.primary.main,
          },
        },
        loadingIndicator: {
          color: theme.palette.common.white,
        },
      },
    },
  };
};
export default LoadingButton;
